module.exports = __webpack_public_path__ + "static/img/avatar.5ca243c3.png";